import React, { useEffect, useState } from 'react'
import WarningModalStyle from './WarningModalStyle'
import WarningImage from '@assets/images/warning.jpg'
import { useTranslation } from 'react-i18next'
import { Modal } from 'antd'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		zIndex: 1000000,
	},
	overlay: {
		background: '#00000099',
	},
}

const WarningModal = ({ getRef = () => {}, onConfirm = () => {} }) => {
	const { t } = useTranslation()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [title, setTitle] = useState(t('enterAllInfo'))

	useEffect(() => {
		const ref = {
			open: (t) => {
				setIsOpenModal(true)
				setTitle(t)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	return (
		<Modal
			open={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			onClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
			footer={null}
		>
			<WarningModalStyle>
				<div className="card z-50">
					<div className="flex justify-center">
						<img
							src={WarningImage}
							alt="error image"
							className="img"
						/>
					</div>
					<h1>{t('warning')}</h1>
					<p className="title">
						{title}
						{'!'}
					</p>

					<div className="centerCard">
						<button
							className="btnN"
							onClick={() => {
								onConfirm()
								setIsOpenModal(false)
							}}
						>
							{t('understand')}
						</button>
					</div>
				</div>
			</WarningModalStyle>
		</Modal>
	)
}

export default WarningModal
